import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { Search, X } from 'lucide-react'
import type { FiltrosSolicitudes, FiltrosDisponibles } from '../types'

const selectClass = "h-10 rounded-md border border-input bg-background px-3 text-sm focus:outline-none focus:border-zinc-400"

interface SolicitudesFiltrosProps {
  filtros: FiltrosSolicitudes
  filtrosDisponibles?: FiltrosDisponibles
  onFiltrosChange: (filtros: FiltrosSolicitudes) => void
  onClear: () => void
}

export function SolicitudesFiltros({
  filtros,
  filtrosDisponibles,
  onFiltrosChange,
  onClear,
}: SolicitudesFiltrosProps) {
  const updateFiltro = (key: keyof FiltrosSolicitudes, value: string | undefined) => {
    onFiltrosChange({ ...filtros, [key]: value || undefined, page: 1 })
  }

  return (
    <div className="flex flex-wrap gap-3 items-end">
      <div className="relative flex-1 min-w-[200px] max-w-[300px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Buscar nombre, correo, teléfono..."
          value={filtros.search || ''}
          onChange={(e) => updateFiltro('search', e.target.value)}
          className="pl-9"
        />
      </div>

      {filtrosDisponibles && (
        <>
          <select
            value={filtros.estado_contacto || ''}
            onChange={(e) => updateFiltro('estado_contacto', e.target.value || undefined)}
            className={`${selectClass} w-[160px]`}
          >
            <option value="">Contacto: Todos</option>
            {filtrosDisponibles.estados_contacto.map((e, i) => (
              <option key={`contacto-${i}-${e.valor}`} value={e.valor}>{e.label}</option>
            ))}
          </select>

          <select
            value={filtros.estado_envio || ''}
            onChange={(e) => updateFiltro('estado_envio', e.target.value || undefined)}
            className={`${selectClass} w-[160px]`}
          >
            <option value="">Envío: Todos</option>
            {filtrosDisponibles.estados_envio.map((e, i) => (
              <option key={`envio-${i}-${e.valor}`} value={e.valor}>{e.label}</option>
            ))}
          </select>

          <select
            value={filtros.estado_entrega || ''}
            onChange={(e) => updateFiltro('estado_entrega', e.target.value || undefined)}
            className={`${selectClass} w-[160px]`}
          >
            <option value="">Entrega: Todos</option>
            {filtrosDisponibles.estados_entrega.map((e, i) => (
              <option key={`entrega-${i}-${e.valor}`} value={e.valor}>{e.label}</option>
            ))}
          </select>

          {filtrosDisponibles.responsables.length > 0 && (
            <select
              value={filtros.responsable_id?.toString() || ''}
              onChange={(e) => updateFiltro('responsable_id', e.target.value || undefined)}
              className={`${selectClass} w-[180px]`}
            >
              <option value="">Responsable: Todos</option>
              {filtrosDisponibles.responsables.map((r) => (
                <option key={r.id} value={r.id.toString()}>{r.nombre}</option>
              ))}
            </select>
          )}
        </>
      )}

      <Button variant="ghost" size="sm" onClick={onClear}>
        <X className="mr-1 h-4 w-4" /> Limpiar
      </Button>
    </div>
  )
}
